import React from 'react';
import { useSelector } from 'react-redux';
import { selectRedirectError } from '../../../../features/redirectError/redirectErrorSlice';

type Props = {
  path?: string;
};

export const RedirectError: React.FC<Props> = () => {
  const error = useSelector(selectRedirectError);

  return <div>{error ? `error=${error.error}&error_reason=${error.reason}` : 'uncaught_error'}</div>;
};
